/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BookmarkedPressReleasesResponseV2AllOf,
    BookmarkedPressReleasesResponseV2AllOfFromJSON,
    BookmarkedPressReleasesResponseV2AllOfFromJSONTyped,
    BookmarkedPressReleasesResponseV2AllOfToJSON,
} from './BookmarkedPressReleasesResponseV2AllOf';
import {
    BookmarkedPressReleasesResponseV2AllOfData,
    BookmarkedPressReleasesResponseV2AllOfDataFromJSON,
    BookmarkedPressReleasesResponseV2AllOfDataFromJSONTyped,
    BookmarkedPressReleasesResponseV2AllOfDataToJSON,
} from './BookmarkedPressReleasesResponseV2AllOfData';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';

/**
 * 保存済みプレスリリース一覧を取得したときのレスポンス（新UI用）
 * @export
 * @interface BookmarkedPressReleasesResponseV2
 */
export interface BookmarkedPressReleasesResponseV2 {
    /**
     * ステータスコード
     * @type {number}
     * @memberof BookmarkedPressReleasesResponseV2
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof BookmarkedPressReleasesResponseV2
     */
    message: string;
    /**
     * 
     * @type {BookmarkedPressReleasesResponseV2AllOfData}
     * @memberof BookmarkedPressReleasesResponseV2
     */
    data: BookmarkedPressReleasesResponseV2AllOfData;
}

export function BookmarkedPressReleasesResponseV2FromJSON(json: any): BookmarkedPressReleasesResponseV2 {
    return BookmarkedPressReleasesResponseV2FromJSONTyped(json, false);
}

export function BookmarkedPressReleasesResponseV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): BookmarkedPressReleasesResponseV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': BookmarkedPressReleasesResponseV2AllOfDataFromJSON(json['data']),
    };
}

export function BookmarkedPressReleasesResponseV2ToJSON(value?: BookmarkedPressReleasesResponseV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': BookmarkedPressReleasesResponseV2AllOfDataToJSON(value.data),
    };
}

